var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { memoize } from '@exadel/esl/modules/esl-utils/decorators';
/** Proxy-interface to access template elements properties */
export class UIPSnippetItem {
    constructor($element) {
        this.$element = $element;
    }
    /** @returns snippet's js element */
    get $elementJS() {
        return this.jsSnippetId ? document.getElementById(this.jsSnippetId) : null;
    }
    /** @returns snippet's note element */
    get $elementNote() {
        return this.noteSnippetId ? document.getElementById(this.noteSnippetId) : null;
    }
    /** @returns snippet's label */
    get label() {
        return this.$element.getAttribute('label') || '';
    }
    /** @returns snippet's js id */
    get jsSnippetId() {
        return this.$element.getAttribute('uip-snippet-js') || '';
    }
    /** @returns snippet's note id */
    get noteSnippetId() {
        return this.$element.getAttribute('uip-snippet-note') || '';
    }
    /** @returns snippet's html content */
    get html() {
        return this.$element.innerHTML;
    }
    /** @returns snippet's js content */
    get js() {
        return this.$elementJS ? this.$elementJS.innerHTML : '';
    }
    /** @returns snippet's note content */
    get note() {
        return this.$elementNote ? this.$elementNote.innerHTML : '';
    }
    /** @returns template to use for isolated rendering */
    get isolatedTemplate() {
        return this.$element.getAttribute('isolated-template') || '';
    }
    /** @returns if snippet should preview in isolated iframe */
    get isolated() {
        return this.$element.hasAttribute('uip-isolated');
    }
    /** @returns snippet's anchor id */
    get anchor() {
        return this.$element.getAttribute('anchor');
    }
    /** @returns if the snippet is in active state */
    get active() {
        return this.$element.hasAttribute('active');
    }
    /** Sets the snippet active state */
    set active(active) {
        var _a, _b;
        this.$element.toggleAttribute('active', active);
        (_a = this.$elementJS) === null || _a === void 0 ? void 0 : _a.toggleAttribute('active', active);
        (_b = this.$elementNote) === null || _b === void 0 ? void 0 : _b.toggleAttribute('active', active);
    }
    /** @returns if the snippet is readonly */
    get isJsReadonly() {
        return this.$element.hasAttribute('uip-js-readonly') || (!this.isolated);
    }
}
__decorate([
    memoize()
], UIPSnippetItem.prototype, "$elementJS", null);
__decorate([
    memoize()
], UIPSnippetItem.prototype, "$elementNote", null);
__decorate([
    memoize()
], UIPSnippetItem.prototype, "label", null);
__decorate([
    memoize()
], UIPSnippetItem.prototype, "jsSnippetId", null);
__decorate([
    memoize()
], UIPSnippetItem.prototype, "noteSnippetId", null);
__decorate([
    memoize()
], UIPSnippetItem.prototype, "html", null);
__decorate([
    memoize()
], UIPSnippetItem.prototype, "js", null);
__decorate([
    memoize()
], UIPSnippetItem.prototype, "note", null);
__decorate([
    memoize()
], UIPSnippetItem.prototype, "isolatedTemplate", null);
